import React, { useState, useEffect } from "react"
import { Card, Typography, Button, Space, Modal, Spin } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import styles from "./index.module.css"
import StripeWrapper from "./StripeWrapper"
import PaymentMethode from "./PaymentMethode"
import PaymentMethodeList from "./PaymentMethodeList"
import { useSelector, useDispatch } from "react-redux"
import { paymentMethodsSelector, getPaymentMethods } from "store/user"
import AddCard from "assets/icons/card_icon.png"

const { Title, Text } = Typography

const PaymentDetails = () => {
  const { t } = useTranslation()
  const paymentMethods = useSelector(paymentMethodsSelector)
  const [loading, setLoading] = useState(false)
  const [showAddCard, setShowAddCard] = useState(false)
  const [activeCardId, setActiveCardId] = useState(null)
  const client = useSelector((store) => store.user)
  const dispatch = useDispatch()
  useEffect(() => {
    if (client?.id) {
      setLoading(true)
      dispatch(getPaymentMethods(client.id)).finally(() => setLoading(false))
    }
  }, [client?.id, dispatch])

  const refreshListWithLoading = () => {
    if (client?.id) {
      setLoading(true)
      dispatch(getPaymentMethods(client.id)).finally(() => setLoading(false))
    }
  }

  return (
    <div className={styles.paymentDetails}>
      <Title level={4} className={`mb-m ${styles.headerTitle}`}>
        {t("payment.payment_details")}
      </Title>
      <StripeWrapper>
        <>
          {(() => {
            if (loading) {
              return <Spin style={{ width: "100%", margin: "40px 0" }} />
            }
            
            return paymentMethods.length > 0 ? (
              <PaymentMethodeList 
                client={client} 
                active={activeCardId} 
                onChange={setActiveCardId} 
                loading={loading} 
                onRefresh={refreshListWithLoading} 
              />
            ) : (
              <Card className={styles.emptyState} bordered={false}>
                <Space direction="vertical" align="center" size="large">
                  <img src={AddCard} alt="Add Card" className={styles.image} />
                  <Text type="secondary">{t("payment.no_payment_methods")}</Text>
                  <Button 
                    type="primary" 
                    shape="round" 
                    icon={<PlusOutlined />} 
                    onClick={() => setShowAddCard(true)}
                  >
                    {t("payment.add_card")}
                  </Button>
                </Space>
              </Card>
            )
          })()}
          {/* Add Card Modal */}
          <Modal open={showAddCard} width={800} onCancel={() => setShowAddCard(false)} footer={null} title={t("payment.add_card")} centered>
            <PaymentMethode
              key={showAddCard ? "add" : "edit"}
              onCancel={() => setShowAddCard(false)}
              onChange={() => {
                setShowAddCard(false)
                refreshListWithLoading()
              }}
              create
            />
          </Modal>
        </>
      </StripeWrapper>
    </div>
  )
}

export default PaymentDetails
